import request from "helper/request";

const driverAPI = {
  getAllDriverVehicleCategories: () => {
    return request.get("/drivers/vehicle-categories/");
  }
};

export default driverAPI;
